type CmsSimpleSite =
  | 'about-us'
  | 'privacy-policy'
  | 'refund-policy'
  | 'responsible-gaming'
  | 'sitemap'
  | 'standard-promotion-and-bonus-terms'
  | 'terms-and-conditions'
  | 'vip-information'
  | 'terms-for-each-sport'
  | 'general-betting-rules';

type CmsLandingSite =
  | 'cash-out'
  | 'loyalty-points'
  | 'mobile-application'
  | 'vip-club'
  | 'player-bets-instruction'
  | 'press'
  | 'cooperation'
  | 'locals';

type CmsSeoLandingSite = 'promo-code' | 'cryptocurrency';

export const cmsSitesLinksMapper: Partial<Record<CmsSimpleSite | CmsLandingSite | CmsSeoLandingSite, string>> = {
  'about-us': 'o-nas',
  'vip-information': 'vip-regulacje',
  'privacy-policy': 'polityka-prywatnosci',
  'terms-and-conditions': 'regulamin',
  'responsible-gaming': 'odpowiedzialna-gra',
  sitemap: 'mapa-strony',
  'terms-for-each-sport': 'specjalny-regulamin',
  'mobile-application': 'pobierz-aplikacje-mobilna',
  'player-bets-instruction': 'player-bets-instrukcja',
  press: 'prasa',
  cooperation: 'wspolpraca',
  locals: 'lokale',
  'promo-code': 'kod-promocyjny',
  cryptocurrency: 'lvbet-bukmacher-kryptowaluty'
};
